import PasswordReset from '@/dialogs/PasswordReset.vue'
import SignUp2 from '@/dialogs/SignUp2.vue'
import Notification from '@/dialogs/Notification.vue'
import ErrorMessage from '@/dialogs/ErrorMessage.vue'
import EmailValidation from '@/dialogs/EmailValidation.vue'

export default {
  methods: {
    openDialog(dialog) {
      switch (dialog) {
        case 'resetPw':
          this.$modal.show(
            PasswordReset,
            null,
            {
              height: 'auto',
              width: 420,
              adaptive: true
            },
            {
              'before-close': () => {
                this.$router.replace('?')
              }
            }
          )
          break
        case 'inschrijven':
          this.$modal.show(
            SignUp2,
            null,
            {
              height: 'auto',
              width: 420,
              scrollable: true
            },
            {
              'before-close': () => {
                this.$router.replace('?')
              }
            }
          )
          break
        case 'v':
          this.$modal.show(
            EmailValidation,
            {
              hash: this.$route.query.k
              /*   loginCallback: () => {
                this.$modal.show('login')
              } */
            },
            {
              height: 'auto',
              width: 360,
              adaptive: true
            },
            {
              'before-close': () => {
                this.$router.replace('?')
              }
            }
          )
      }
    },
    notificationDialog(title, text, time) {
      this.$modal.show(
        Notification,
        {
          title: title,
          text: text,
          time: time || 3000
        },
        {
          width: 380,
          adaptive: true
        }
      )
    },
    errorDialog(title, text) {
      this.$modal.show(
        ErrorMessage,
        {
          title: title,
          text: text
        },
        {
          height: 'auto',
          width: 380,
          adaptive: true
        }
      )
    }
  }
}
